// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ButtonToolbar,
  Image
} from 'react-bootstrap';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';
import { validateRequired, validateFileName } from '../../helpers';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import AusMap from '../../images/australia.png';
import type { MapStateToProps } from 'react-redux';

type Params = {
  campaignId: number,
  organisationId: number,
  context: string
};

type Props = {
  params: Params,
  successMsg: string,
  errorMsg: string,
  formValues: Object,
  bookingId: any,
  currentCampaign: Object,
  handleSubmit: Function,
  onSubmit: Function,
  cloneCampaign: Function,
  archiveCampaign: Function,
  campaignId: any,
  isArchiving: boolean,
  isSaving: boolean
};

class CampaignForm extends React.Component<Props> {
  render() {
    const {
      params: { campaignId, organisationId, context },
      bookingId,
      formValues,
      handleSubmit,
      onSubmit
    } = this.props;
    const displaySelectMsg = !campaignId;
    const archiveBtnText =
      formValues && formValues.isArchived ? 'Unarchive' : 'Archive';
    const archiveLoadingText =
      formValues && formValues.isArchived ? 'Unarchiving...' : 'Archiving...';

    if (displaySelectMsg) {
      return (
        <div>
          <Link
            to={`/${context}/${organisationId}/campaigns/new`}
            className="well-300"
          >
            <Image src={AusMap} />
            <Button bsStyle="primary">Create new Campaign</Button>
          </Link>
        </div>
      );
    } else {
      return (
        <div>
          <Form
            onSubmit={handleSubmit(vals =>
              onSubmit({ ...vals, button: 'Map' })
            )}
            className="campaign-form"
          >
            <Row>
              <Col xs={12}>
                <Row>
                  <FormGroup>
                    <Col sm={9}>
                      <Field
                        component={Input}
                        type="text"
                        placeholder="Campaign name"
                        name="name"
                        label="Campaign name*"
                        htmlFor="campignName"
                        id="campignName"
                        validate={[validateRequired, validateFileName]}
                        disabled={
                          this.props.currentCampaign &&
                          this.props.currentCampaign.isLocked
                        }
                      />
                    </Col>
                  </FormGroup>
                </Row>

                <Row>
                  <FormGroup>
                    <Col sm={9}>
                      <Field
                        className="inline-block"
                        component={Input}
                        type="textarea"
                        placeholder="Describe your campaign here. This information will appear in the Campaign Summary Report."
                        name="notes"
                        label="Campaign description"
                        componentClass="textarea"
                        rows="4"
                        infoIcon="Coming soon"
                        disabled={
                          this.props.currentCampaign &&
                          this.props.currentCampaign.isLocked
                        }
                      />
                    </Col>
                  </FormGroup>
                </Row>

                <Row>
                  <FormGroup>
                    <Col sm={9}>
                      <Field
                        component={Input}
                        type="autocomplete"
                        placeholder="Enter an address, postcode, suburb or leave blank to decide on the map"
                        name="address"
                        label="Where would you like to start?"
                        infoIcon="Coming soon"
                        disabled={
                          this.props.currentCampaign &&
                          this.props.currentCampaign.isLocked
                        }
                      />
                    </Col>
                  </FormGroup>
                </Row>
              </Col>
            </Row>

            <Row className="section actions">
              <Col xs={12}>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <ButtonToolbar className="pull-right">
                      {bookingId && (
                        <Link
                          to={`/${context}/${organisationId}/bookings/${bookingId}`}
                          className="btn btn-link"
                        >
                          View Booking
                        </Link>
                      )}
                      {!!this.props.campaignId && (
                        <Button
                          bsStyle="link"
                          type="button"
                          onClick={e =>
                            this.props.cloneCampaign(this.props.currentCampaign)
                          }
                        >
                          Copy
                        </Button>
                      )}
                      {!!this.props.campaignId && (
                        <Button
                          bsStyle="link"
                          type="button"
                          disabled={this.props.isArchiving}
                          onClick={() =>
                            this.props.archiveCampaign(this.props.formValues)
                          }
                        >
                          {this.props.isArchiving
                            ? archiveLoadingText
                            : archiveBtnText}
                        </Button>
                      )}
                      <Button
                        bsStyle="default"
                        type="button"
                        disabled={this.props.isSaving}
                        onClick={handleSubmit(vals =>
                          onSubmit({ ...vals, button: 'Save' })
                        )}
                      >
                        {this.props.isSaving ? 'Saving...' : 'Save'}
                      </Button>

                      <Button
                        bsStyle="primary"
                        type="submit"
                        onClick={handleSubmit(vals =>
                          onSubmit({ ...vals, button: 'Map' })
                        )}
                      >
                        Map It
                      </Button>
                    </ButtonToolbar>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col sm={9}>
                <CSSTransitionGroup
                  transitionName="fade"
                  transitionEnterTimeout={300}
                  transitionLeaveTimeout={300}
                >
                  {this.props.successMsg && (
                    <p className="text-success text-right">
                      {this.props.successMsg}
                    </p>
                  )}
                </CSSTransitionGroup>
              </Col>
            </Row>
          </Form>
          {this.props.errorMsg && (
            <div className="alert alert-danger">{this.props.errorMsg}</div>
          )}
        </div>
      );
    }
  }
}

// Decorate the form component
CampaignForm = reduxForm({
  form: 'campaignForm'
})(CampaignForm);

const selector = formValueSelector('campaignForm');

const mapStateToProps: MapStateToProps<*, *, *> = state => {
  return {
    formValues: getFormValues('campaignForm')(state),
    campaignId: selector(state, 'id'),
    bookingId: state && state.currentCampaign && state.currentCampaign.bookingId
  };
};

export default connect(mapStateToProps)(CampaignForm);



// WEBPACK FOOTER //
// ./src/containers/campaigns/CampaignForm.js